export default "__VITE_ASSET__Bkd8JJa8__"